import moment from 'moment';
import getViewType from './getViewType';

const checkIsHostScheduleEnabled = (queryParams) => {
  const params = new URLSearchParams(window.location.search);
  const yearMonthQuery = params.get('yearMonth');

  if (!yearMonthQuery) return false;

  const currentMonth = moment().format('YYYY-MM');
  const selectedYearMonth = moment(yearMonthQuery).format('YYYY-MM');

  const queryExist = Boolean(queryParams?.startDate && queryParams?.endDate);

  if (!queryExist) return false;

  const viewType = getViewType();

  switch (viewType) {
    case 'upcoming':
      return selectedYearMonth >= currentMonth;

    case 'past':
      return selectedYearMonth <= currentMonth;

    case 'scheduled':
      return true;

    default:
      return false;
  }
};

export default checkIsHostScheduleEnabled;
